export default "__VITE_ASSET__D4gqCt3I__"